import $ from 'jquery'

$(document).ready(function() {
	$('#internal-nav .section-title').click(function() {
		$(this).toggleClass('is-active')
	})
})
